/* eslint-disable @typescript-eslint/no-explicit-any */
import {Box} from '@mui/material';
import {cloneDeep} from 'lodash';
import {GetServerSidePropsContext} from 'next';
import ErrorPage from 'next/error';
import React from 'react';
import {BlockRenderer} from '~/components/renderer/block-renderer';
import {GLOBAL_TYPE} from '~/constants/content-map-type';
import {usePageSetting} from '~/providers/page-context.provider';
import {handleConvertToLocaleContentful} from '~/utils';
import {getGloablByType} from '~/utils/global-operations';
import {getPageData} from '../[[...slug]]/index.page';

type SupportQExt = {
  data: any;
  dataPagePolicy: any;
};

const Support: React.FC<SupportQExt> = ({data, dataPagePolicy}) => {
  const page = data?.pageCollection?.items[0];
  const {globalData} = usePageSetting();
  const dataTranslation = globalData?.dataTranslation?.[0] ?? {};
  if (!page) {
    return <ErrorPage statusCode={404} />;
  }
  const block: Array<any> = [page.sectionCollection?.items, page.seoStandard].filter(
    block => !!block
  );

  const blockCopy = cloneDeep(block);

  blockCopy[0]?.map((section: any, idx: number) => {
    if (section?.blocksCollection?.items[0]?.__typename === 'SupportFaq') {
      blockCopy[0][idx].blocksCollection.items[0] = {
        ...blockCopy[0][idx].blocksCollection.items[0],
        dataPagePolicy: dataPagePolicy ?? [],
        title: dataTranslation['support-header'],
        secondaryTitle: dataTranslation['support-title-our-terms-and-policies'],
        ordersLabel: dataTranslation['support-tabs-orders'],
        shippingAndDeliveryLabel: dataTranslation['support-tabs-shipping-and-delivery'],
        returnAndRefundsLabel: dataTranslation['support-tabs-returns-and-refunds'],
        disscountCodeLabel: dataTranslation['support-tabs-discount-codes'],
        popularQuestionsLabel: dataTranslation['support-title-popular-questions'],
        supportInfoTitle: dataTranslation['support-title-have-other-questions'],
        supportButtonLabel: dataTranslation['support-title-contact-us'],
        __typename: 'SupportFaq',
      };
    }
  });

  // const subscribe = {
  //   __typename: 'SubscribePopup',
  // };

  // Handle remove section when empty data
  const handleRemoveSectionWhenEmptyItem = () => {
    blockCopy[0].map((blockItem: any, idx: number) => {
      if (blockItem?.blocksCollection?.items[0]?.listItemCollection?.items?.length <= 0) {
        blockCopy[0].splice(idx, 1);
      }
    });
  };
  handleRemoveSectionWhenEmptyItem();

  return (
    <Box
      sx={{
        width: '100%',
        overflowX: 'hidden',
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <BlockRenderer block={[...blockCopy]} />
    </Box>
  );
};

export const getStaticProps = async (ctx: GetServerSidePropsContext) => {
  const preview = !!(process && process.env && process.env.NEXT_PUBLIC_PREVIEW);

  const promises: [ReturnType<typeof getPageData>, ReturnType<typeof getGloablByType>] = [
    getPageData({slug: 'support', preview}, ctx),
    getGloablByType(
      handleConvertToLocaleContentful(ctx.locale as string),
      GLOBAL_TYPE.listPagePolicy
    ),
  ];

  const [pageData, dataPagePolicy] = await Promise.all(promises);
  const {data} = pageData;

  return {
    props: {
      data,
      locale: ctx.locale,
      dataPagePolicy,
    },
    revalidate: 60 * 5,
  };
};

export default Support;

export const config = {
  api: {
    bodyParser: false,
  },
};
